
<main>
  <section>
    <div class="container-fluid ptb-42">
      <div class="row">
        <div class="col-auto">
          <div class="titles-bdr-r">
            <h1 class="color-primary fs-325remTitles">Viagens Ocasionais</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="container pb-120 gx-5 gx-lg-0">
      <div class="row justify-content-center">
        <div class="col-12">

        </div>
      </div>
    </div>
  </section>
</main>

